export default __webpack_public_path__ + "static/media/graxalta_GxD_png_webdesign2021_blueleaf01.9a16ecaa.png";